import { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { sendEvent, LEAD_API_URL } from './Config';

function isValidObjectId(id) {
    return /^[0-9a-fA-F]{24}$/.test(id);
}

const Init = function () {
    const { lead_id } = useParams();
    const navigate = useNavigate();

    async function loadLeadId(lead_id) {
        try {
            console.log("loadLeadId");
            const res = await fetch(`${LEAD_API_URL}/onboarding/lead/${lead_id}`);

            if (!res.ok) return;

            const json = await res.json();

            localStorage.setItem("lead_id", lead_id);

            if (json?.documentNumber) {
                localStorage.setItem("nif", json.documentNumber);
            }

            if (json?.email) {
                localStorage.setItem("email", json.email);
            }

            navigate(`/onboarding/view-pdf/${lead_id}`)
        } catch (e) {

        }
    }

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const utmSource = urlParams.get('utm_source');

        sendEvent(lead_id ?? false, "website-opened");

        if (lead_id) {
            loadLeadId(lead_id);
            return;
        }

        localStorage.setItem("utm_source", utmSource);

        navigate("/onboarding");
    }, []);

    return <></>;
}

export default Init;